import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterface, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections, setFinanceActiveDiscount} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import {shouldUseMultipleWorkSheets} from "./discountFunctions";

class Discount extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount} = this.props;
    const disabled = this.isDiscountDisabled();
    return (
      <li className={"discount" + (disabled ? " discount--disabled" : "")}>
        <div className="discount-cell discount-cell--select">
          <button className={"ui-checkbox" + (discount.selected ? " ui-checkbox--checked" : "")}
                  onClick={this.handleDiscountSelectClick}/>
        </div>
        <div className="discount-cell discount-cell--name bold" onClick={this.handleDiscountSelectClick}>
          {discount.selected ? discount.name : null}
        </div>
        {discount.selected ? (
          <div className="discount-cell discount-cell--amount bold">
            {this.getDiscountAmount()}
          </div>
        ) : null}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, workSheetsCount, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorSettings: store.fabricatorState.settings,
    fabricatorData: store.fabricatorState,
    allWizardsValues,
    activeQuoteIndex,
    quotes,
    workSheetsCount,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financeActiveDiscount,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setFinanceActiveDiscount,
};

export default connect(mapStateToProps, mapDispatchToProps)(Discount);
